import React, { useState } from 'react'
import expandIcon from '@/pages/dashboard/assets/svg/expand.svg'
import expandActiveIcon from '@/pages/dashboard/assets/svg/expand-active.svg'
import foldActiveIcon from '@/pages/dashboard/assets/svg/fold-active.svg'
import foldIcon from '@/pages/dashboard/assets/svg/fold.svg'

import './index.scss'

const FoldButton = (props: any) => {
  const {
    isExpand = false
  } = props
  const [mouseEnter, setMouseEnter] = useState(false)

  return (
    <i
      className='fold-toggle-btn'
      onMouseEnter={() => {
        setMouseEnter(true)
      }}
      onMouseLeave={() => {
        setMouseEnter(false)
      }}
    >
      {
        isExpand ? (
          <img src={mouseEnter ? foldActiveIcon : foldIcon}/>
        ) : (
          <img src={mouseEnter ? expandActiveIcon : expandIcon}/>
        )
      }
    </i>
  )
}

export default FoldButton
